import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { selectAccount } from 'next/entities/account';
import { selectFeature, NEW_NAV } from 'next/entities/features';
import { stop, selectSpoofing } from 'next/entities/spoofing';
import { NegativeBanner } from 'next/components/ui';

const CancelSpoof = styled.button`
  background: transparent;
  border: none;
  color: var(--white);
  font-size: var(--medium-large);
  font-weight: var(--bold);
  text-decoration: underline;

  &:hover {
    color: var(--nav-spoof-hover);
  }
`;

const Wrapper = styled(NegativeBanner)`
  font-size: var(--medium-large);
`;

export const SpoofBanner = ({ accountId, hasNewNav, onDespoof, spoofing }) => {
  if (!(hasNewNav && spoofing)) {
    return null;
  }

  return (
    <Wrapper>
      Spoofing Account {accountId}{' '}
      <CancelSpoof onClick={onDespoof}>Stop spoofing</CancelSpoof>
    </Wrapper>
  );
};

SpoofBanner.propTypes = {
  accountId: PropTypes.string,
  hasNewNav: PropTypes.bool,
  onDespoof: PropTypes.func,
  spoofing: PropTypes.bool,
};

const mapStateToProps = state => ({
  accountId: selectAccount(state).id,
  hasNewNav: selectFeature(state, NEW_NAV),
  spoofing: selectSpoofing(state),
});

const mapDispatchToProps = {
  onDespoof: stop,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpoofBanner);
